<template>
  <div id="adminroletree">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="'管理选角色'" :name="'first'"></el-tab-pane>
      <el-tab-pane :label="'角色选管理'" :name="'second'"></el-tab-pane>
    </el-tabs>

    <el-row v-if="activeName == 'tab-first'">
      <el-col :span="10">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          height="650"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column align="center" prop="admin_id" label="管理员ID">
          </el-table-column>
          <el-table-column align="center" prop="admin_name" label="管理员名称">
          </el-table-column>
          <el-table-column align="center" prop="admin_status" label="状态">
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="initRole(scope.row.admin_id)"
                >处理角色</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col v-loading="loading" :span="12" :offset="2">
        关联角色管理
        <el-tree
          ref="tree"
          :data="tree"
          :check-strictly="true"
          :props="props"
          node-key="id"
          show-checkbox
          :default-checked-keys="checked"
          :default-expanded-keys="expanded"
        >
        </el-tree>
        <el-button type="primary" size="mini" @click="submitRole()"
          >提交</el-button
        >
      </el-col>
    </el-row>

    <el-row v-if="activeName == 'tab-second'">
      <el-col :span="10">
        <el-tree
          :data="roleList"
          :check-strictly="true"
          :props="props"
          node-key="id"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </el-col>

      <el-col :span="10">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          height="650"
          :data="adminList"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column align="center" prop="admin_id" label="管理员ID">
          </el-table-column>
          <el-table-column align="center" prop="admin_name" label="管理员名称">
          </el-table-column>
          <el-table-column align="center" prop="admin_status" label="状态">
          </el-table-column>
          <el-table-column label="处理" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <input
                type="checkbox"
                :admin_id="scope.row.admin_id"
                :checked="exnamination(scope.row.admin_id)"
                @change="handleSelectData(scope.row.admin_id)"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" size="mini" @click="submitData()"
          >提交</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      list: [],
      form: {},
      loading: false,
      url: "/erp/Admin/getAdminList",
      status: 100,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      multipleSelection: [],
      tree: [],
      expanded: [],
      checked: [],
      isEdit: true,
      props: {
        children: "children",
        label: "label",
      },
      admin_id: 0,
      roleList: [],
      adminList: [],
      checkedAdmin: [],
      activeName: "tab-first",
      tempRoleId: 0,
    };
  },
  computed: {},
  methods: {
    submitData() {
      let role_id = this.tempRoleId;
      let admin_ids = this.checkedAdmin;

      if (!role_id) {
        this.$message.error("请选择角色");
        return false;
      }

      if (admin_ids.length < 1) {
        this.$message.error("请选择用户");
        return false;
      }

      this.$http
        .post("/erp/Admin/saveRoleAdmin", {
          role_id: role_id,
          admin_id: admin_ids,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
          }
          if (res.data.code != 200) {
            this.$message.error("提交成功");
          }
          return;
        });
    },
    //处理选中的data
    handleSelectData(admin_id) {
      let index = this.checkedAdmin.indexOf(admin_id);
      if (index >= 0) {
        this.checkedAdmin.splice(index, 1);
      } else {
        this.checkedAdmin.push(admin_id);
      }
      this.exnamination(admin_id);
    },
    //检测checkbox是否选中
    exnamination(admin_id) {
      if (this.checkedAdmin.indexOf(admin_id) >= 0) {
        return true;
      }
      return false;
    },
    //节点点击
    handleNodeClick(d, n) {
      let id = d.id;
      this.tempRoleId = id;
      this.tableLoading = true;
      this.$http
        .post("/erp/Admin/getAdminRoleCheckTree", { role_id: id })
        .then(res => {
          if (res.data.code == 200) {
            this.adminList = res.data.data.list;
            this.checkedAdmin = res.data.data.checked;
          }
          this.tableLoading = false;
          if (res.data.code != 200) {
            this.$message.error(res.data.msg);
          }
        });
    },
    //tab切换
    handleClick(tab, event) {
      let node = event.target.getAttribute("id");
      this.activeName = node;
      if (node == "tab-second") {
        this.fetchRoleTree();
      }
    },
    fetchRoleTree() {
      this.loading = true;
      this.$http.post("/erp/AdminRole/getAdminRoleTree").then(res => {
        if (res.data.code == 200) {
          this.roleList = res.data.data.tree;
        }
        this.loading = false;
        if (res.data.code != 200) {
          this.$message.error(res.data.code);
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.list = res.data.data.list;
        }
      });
    },
    initRole(id) {
      // 初始关联的权限数据
      var _this = this;
      this.admin_id = id;
      this.$http
        .post("/erp/Admin/getAdminToRoleTree", {
          admin_id: id,
        })
        .then(function(res) {
          if (res.data.code === 200) {
            _this.tree = res.data.data.tree;
            _this.expanded = res.data.data.checked;
            _this.$refs.tree.setCheckedKeys(res.data.data.checked);
          }
          _this.loading = false;
          if (res.data.code !== 200) {
            _this.tree = [];
            _this.$message.error(res.data.msg);
            return;
          }
        });
    },
    submitRole() {
      /* 提交权限关联数据 */
      var _this = this;
      this.$http
        .post("/erp/Admin/saveAdminJoinRole", {
          admin_id: this.admin_id,
          role_ids: this.$refs.tree.getCheckedKeys(),
        })
        .then(function(res) {
          if (res.data.code !== 200) {
            _this.$message.error(res.data.msg);
            return;
          }
          if (res.data.code === 200) {
            _this.$message({
              type: "success",
              message: "修改成功!",
            });
            return;
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/AdminList.vue